

























































































































import { Component, Emit, Mixins, Prop, Watch } from 'vue-property-decorator'
import IconsMixin from '@/mixins/IconsMixin.vue'
import AuthMixin from '@/mixins/AuthMixin.vue'
import LoadingPage from '@/components/LoadingPage.vue'
import LabeledValue from '@/components/LabeledValue.vue'
import axios from 'axios'
import {
  Barcode,
  BarcodeMapper,
  Company,
  IVendorPriceListEntry,
  Order,
  OrderEntry,
  PriceList,
  PriceListCollection,
  PriceListEntry
} from 'serverless-firestore'
import DynamsoftBarcodeScanner from '@/components/Barcode/DynamsoftBarcodeScanner.vue'
import CategorySelectionModal from '@/components/Order/CategorySelectionModal.vue'
import compatibility from '@/services/compatibility.service'
import PriceListSelector from '@/components/Order/PriceListSelector.vue'
import AddVendorModal from '@/components/Onboarding/AddVendorModal.vue'
import ProductSelector from '@/components/Order/ProductSelector.vue'
import { OrderEntryStatusEnum } from 'serverless-firestore/lib/Order/OrderEntry/OrderEntryStatusEnum'
import QuantityTypeSelector from '@/components/Order/QuantityTypeSelector.vue'
import { v4 as uuid } from 'uuid'

@Component({
  components: {
    DynamsoftBarcodeScanner,
    LabeledValue,
    LoadingPage,
    CategorySelectionModal,
    PriceListSelector,
    AddVendorModal,
    ProductSelector,
    QuantityTypeSelector
  }
})
export default class OrderBarcodeScanDialog extends Mixins(IconsMixin, AuthMixin) {
  @Prop({ type: Boolean, default: false })
  public show!: boolean

  public showScanner = true

  @Prop({ type: Array, required: true })
  public priceListEntries!: IVendorPriceListEntry[]

  @Prop({ type: Array, required: true })
  public vendors!: Company[]

  @Prop({ type: Array, required: true })
  public priceLists!: PriceList[]

  @Prop({ type: Object, required: true })
  public order!: Order

  public details: OrderEntry | null = null

  public vendorPriceListEntries: IVendorPriceListEntry[] = []
  public showAddVendorModal = false
  public newVendor: {
    name: string,
    phoneNumber: string,
    email: string} = {
      name: '',
      phoneNumber: '',
      email: ''
    }

  public lookingUpBarcode: boolean = false
  public invalidLastScan: boolean | null = null
  public invalidLastScanTimeout: number | null = null
  public isNotInVendorPriceList: boolean | null = null

  public quantity: number | null = null
  public formValid: boolean = false

  public getUserMedia = compatibility.getUserMedia

  public $refs!: {
    barcodeScanner: DynamsoftBarcodeScanner
    vendor: HTMLSelectElement
    description: HTMLInputElement
    quantity: HTMLInputElement
    form: HTMLFormElement
  }

  @Emit()
  public hide() {}

  @Emit('added')
  public async addToOrder() {
    if (!this.details || !this.details.priceListId || !this.details.vendorCompanyId) {
      return
    }

    const entry = this.createOrderEntry(this.details)
    entry.description = this.details ? this.details.description : entry.description
    entry.orderingNotes = this.details ? this.details.orderingNotes : entry.orderingNotes

    await this.reset()
    return entry
  }

  @Emit('populatePriceListEntries')
  public async populatePriceListEntries() {}

  @Watch('show')
  public onShowChange(show: boolean) {
    console.log('show changed:', show)
    if (!show) {
      console.log('hide scanner')
      this.showScanner = false
      // @ts-ignore
      this.$refs.barcodeScanner.stopScanning()
    } else if (this.$refs.barcodeScanner) {
      console.log('show scanner')
      this.showScanner = true
      // @ts-ignore
      this.$refs.barcodeScanner.startScanning()
    }
  }

  public async onScannedBarcode(upc: string) {
    this.showScanner = false

    const createdPriceListEntries = this.listVendorPriceListEntries(upc)
    const barcode = createdPriceListEntries.length ?
        createdPriceListEntries[0].barcode : await this.lookupBarcodeUsingRemoteDB(upc)

    const providingPriceListIds = createdPriceListEntries.map((entry: IVendorPriceListEntry) => entry.priceListId)
    const alternatePriceListEntries = this.priceLists
      .filter((priceList: PriceList) => !providingPriceListIds.includes(priceList.id))
      .map((priceList: PriceList) => this.buildVendorEntryForBarcode(priceList, upc, barcode))

    this.quantity = 1
    this.vendorPriceListEntries = [ ...createdPriceListEntries, ...alternatePriceListEntries ]
    this.displayDefaultPriceListSelection(
      createdPriceListEntries.length ? createdPriceListEntries[0].priceListId : null,
      createdPriceListEntries.length ? createdPriceListEntries[0].id : null
    )
  }

  public async reset() {
    this.vendorPriceListEntries = []
    this.quantity = null
    this.details = null
    this.showScanner = true

    // @ts-ignore
    await this.$refs.barcodeScanner.resetScanner()
  }

  public async loadVendors(newCompany?: any) {
    this.showAddVendorModal = false

    // refresh the vendor list
    this.populatePriceListEntries()

    if(newCompany && newCompany.id && this.details) {
      this.details.vendorCompanyId = newCompany.id
      this.$refs.form.validate()
    }
  }

  public addVendor() {
    this.newVendor = {
      name: '',
      phoneNumber: '',
      email: ''
    }
    this.showAddVendorModal = true
  }

  public updateQuantityTypeSelection(quantityType: any) {
    if(!this.details) {
      return
    }

    this.details.quantityType = quantityType
  }

  protected invalidScan() {
    this.invalidLastScan = true
    if (this.invalidLastScanTimeout) {
      clearTimeout(this.invalidLastScanTimeout)
    }

    this.invalidLastScanTimeout = window.setTimeout(() => {
      this.invalidLastScan = false
      this.invalidLastScanTimeout = null
    }, 2000)

    this.$refs.description.focus()
  }

  protected displayDefaultPriceListSelection(priceListId: string | null, priceListEntryId: string | null) {
    if (!this.details) {
      this.details = new OrderEntry('', '')
    }

    if (priceListId) {
      this.details.priceListId = priceListId
    }
    if (priceListEntryId) {
      this.details.priceListEntryId = priceListEntryId
    }

    this.details.updateVendorDetails(this.findSelectedVendorPriceListEntry() || this.vendorPriceListEntries[0])

    this.$nextTick(() => {
      if (this.details && !this.details.description) {
        this.invalidScan()
      } else {
        this.$refs.quantity.focus()
      }
    })
  }

  protected buildVendorEntryForBarcode(
    priceList: PriceList,
    upc: string,
    barcode: Barcode | null | undefined
  ): IVendorPriceListEntry {
    let entry: IVendorPriceListEntry = {
      id: uuid(),
      upc,
      vendorCompanyId: priceList.vendorCompanyId,
      priceListId: priceList.id,
      description: ''
    }

    if (barcode) {
      entry = {
        ...entry,
        description: barcode.name,
        barcode: barcode,
        category: barcode.category
      }
    }

    return entry
  }

  protected listVendorPriceListEntries(upc: string): IVendorPriceListEntry[] {
    return this.priceListEntries.filter((entry: IVendorPriceListEntry) => {
      return entry.upc === upc
    })
  }

  protected async lookupBarcodeUsingRemoteDB(upc: string): Promise<Barcode | null> {
    this.lookingUpBarcode = true
    try {
      return ( new BarcodeMapper ).map(( await axios.get(`/api/barcode/${ upc }`) ).data)
    } catch (e) {
      return null
    } finally {
      this.lookingUpBarcode = false
    }
  }

  protected createOrderEntry(selectedPriceListEntry: OrderEntry) {
    const entry = new OrderEntry('', '')
    entry.updateVendorDetails(selectedPriceListEntry)
    if (this.quantity !== null) {
      entry.quantity = this.quantity
    }

    if(this.details && this.details.quantityType) {
      entry.quantityType = this.details.quantityType
    }

    if(this.details && this.details.priceListEntryId) {
      entry.priceListEntryId = this.details.priceListEntryId
    }

    return entry
  }

  protected findSelectedVendorPriceListEntry() {
    if(!this.details || !this.details.vendorCompanyId) {
      return
    }

    const priceListId = this.details.priceListId
    return this.vendorPriceListEntries
        .find((entry: IVendorPriceListEntry) => {
          if(!entry || !entry.priceListId) {
            return false
          }

          return entry.priceListId === priceListId
        })
  }

  protected async lookupVendorPriceList(priceListCollection: PriceListCollection, entry: OrderEntry) {
    if (!entry.vendorCompanyId) {
      return
    }

    return await priceListCollection.get(entry.priceListId)
  }

  private isBarcodeInVendorPriceLists(upc: string) {
    return this.listVendorPriceListEntries(upc).length > 0
  }

  private createVendorPriceListEntries(upc: string, barcode: Barcode | null) {
    return this.priceLists.map((priceList: PriceList) => this.buildVendorEntryForBarcode(priceList, upc, barcode))
  }
}
